var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 80,
    viewBox: "0 0 128 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.06 46.59C32.06 55.36 24.77 62.59 16 62.59C10.18 62.59 4.99 59.39 3.39 56.7V62.46H0V0H3.39V36.48C4.99 33.86 10.17 30.59 16 30.59C24.77 30.59 32.06 37.82 32.06 46.59ZM28.6 46.59C28.6 39.55 23.1 33.98 15.99 33.98C8.88 33.98 3.38 39.55 3.38 46.59C3.38 53.63 8.95001 59.2 15.99 59.2C23.03 59.2 28.6 53.63 28.6 46.59Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.93 62.94H76.54V57.05C74.94 59.67 69.76 62.94 64 62.94C55.23 62.94 48 55.64 48 46.94C48 38.24 55.23 31 64 31C69.76 31 74.94 34.2 76.54 36.82V31.06H79.93V62.93V62.94ZM76.54 46.94C76.54 39.96 70.97 34.4 64 34.4C57.03 34.4 51.39 39.97 51.39 46.94C51.39 53.91 56.96 59.55 64 59.55C71.04 59.55 76.54 53.98 76.54 46.94Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/BAG.fdbbb3c6f04c8a7f7ece93997d781e82.svg";
export { ForwardRef as ReactComponent };